import React, { useEffect } from 'react';

const SmartEditorSkin: React.FC = () => {
  useEffect(() => {
    // SmartEditor2Skin.html의 내용을 동적으로 로드
    const loadEditorSkin = async () => {
      try {
        const response = await fetch('/static/smarteditor/SmartEditor2Skin.html');
        const html = await response.text();
        document.body.innerHTML = html;
      } catch (error) {
        console.error('Error loading SmartEditor skin:', error);
      }
    };
    
    loadEditorSkin();
  }, []);

  return null;
};

export default SmartEditorSkin;
